import React, { useState } from 'react'
import styled from 'styled-components'
import { map } from 'lodash-es'
import { getThemeStyle } from '../../utilities/helpers'
import ChartBg from '../../images/driver-map-grid-bg.svg'
import { TABLET } from '../../utilities/breakpoints'

const DriverResultMap = ({drivers, useTranslate}) => {

  const [activeElement, setActiveElement] = useState(null);

  const getLetter = (index) => {
    if ([0, 3, 6, 9, 12, 15].includes(index)) {
      return "A"
    } else if ([1, 4, 7, 10, 13, 16].includes(index)) {
      return "B"
    } else {
      return "C";
    }
  }

  return (
    <MapContainer>
      <DriverChartWrapper>
        <DriverChart>
          <ChartContainer>
            <div className="chart-bg" style={{backgroundImage: `url(${ChartBg})`}} />
            <div className={`chart-results ${activeElement !== null ? 'show-active' : ''}`}>
              {map(drivers, (driver, index) => {
                const xLocation = driver.result;
                const yLocation = 100 - ((driver.importance - 1) / 4)*100;

                if (driver.result !== null && driver.result !== undefined && driver.importance) {
                  return (
                    <ItemNumber
                      className={`driver-index ${index === activeElement ? 'active' : ''}`}
                      key={index}
                      style={{
                        backgroundColor: getThemeStyle(driver.surveyThemeIndex).bgColor,
                        left: `${xLocation}%`,
                        top: `${yLocation}%`
                      }}
                    >
                      {getLetter(index)}
                    </ItemNumber>
                  )
                }
              })}
            </div>
            <div className="axis axis-x">
              <div className="values">
                <span className="val-1">0%</span>
                <span className="val-2">25%</span>
                <span className="val-3">50%</span>
                <span className="val-4">75%</span>
                <span className="val-5">100%</span>
              </div>
              <div className="axis-label">{useTranslate('data_vault.current_state')}</div>
            </div>
            <div className="axis axis-y">
              <div className="axis-label">{useTranslate('data_vault.importance')}</div>
              <div className="values">
                <span className="val-1">1</span>
                <span className="val-2">2</span>
                <span className="val-3">3</span>
                <span className="val-4">4</span>
                <span className="val-5">5</span>
              </div>
            </div>
          </ChartContainer>
        </DriverChart>
      </DriverChartWrapper>

      <DriverList className="driver-list">
        {map(drivers, (driver, index) => (
          <DriverListItem
            className={`driver-list-item ${driver.result !== null && driver.result !== undefined && driver.importance ? '' : 'no-result'}`}
            key={index}
            onMouseEnter={() => setActiveElement(index)}
            onMouseLeave={() => setActiveElement(null)}
          >
            <ItemNumber className="driver-index" style={{backgroundColor: getThemeStyle(driver.surveyThemeIndex).bgColor}}>{getLetter(index)}</ItemNumber>
            <ItemTitle className="driver-title">{driver.title}</ItemTitle>
            {/*<div className="item-results">Res:{driver.result && driver.result.toFixed(1)} Rate:{driver.importance && driver.importance.toFixed(1)}</div>*/}
          </DriverListItem>
        ))}
      </DriverList>
    </MapContainer>
  )
}

export default DriverResultMap;

const MapContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media${TABLET} {
    flex-direction: row;
    flex-wrap: nowrap;
  }
`;

const DriverChartWrapper = styled.div`
  padding: 0 0 50px 50px;
  flex: 0 1 100%;
  margin-bottom: 30px;
`;

const DriverChart = styled.div`
  position: relative;
`;

const ChartContainer = styled.div`
  position: relative;
  height: 0;
  width: 100%;
  padding-bottom: 100%;
  background-color: #fafafa;
    
  .chart-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
  }
  
  .chart-results {
    position: absolute;
    left: 10%;
    top: 10%;
    width: 80%;
    height: 80%;
    
    .driver-index {
      position: absolute;
      transform: translate(-50%, -50%);
      cursor: pointer;
      transition: all .3s ease-in-out;
      
      &:hover {
        z-index: 10;
      }
    }
    
    &.show-active .driver-index {
      z-index: 1;
      opacity: .05;
      
      &.active {
        z-index: 10;
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.2);
        transform-origin: center;
      }
    }
  }
  
  .axis-x {
    top: 100%;
    border-top: 1px solid #5F7D95;
  }
  
  .axis-y {
    top: 100%;
    transform: rotate(-90deg) translateX(50px);
    transform-origin: bottom left;
    border-bottom: 1px solid #5F7D95;
  }
  
  .axis {
    position: absolute;
    left: 0;
    width: 100%;
    height: 50px;
    
    .axis-label {
      width: 100%;
      text-align: center;
      font-style: italic;
      color: #5F7D95;
      line-height: 1;
    }
    
    .values {
      position: relative;
      height: 30px;
      
      span {
        display: block;
        position: absolute;
        left: auto;
        top: 50%;
        color: #5F7D95;
        font-size: 14px;
        font-weight: 500;
        transform: translate(-50%, -50%);
      }
      
      .val-1 {
        left: 10%;
      }
      .val-2 {
        left: 30%;
      }
      .val-3 {
        left: 50%;
      }
      .val-4 {
        left: 70%;
      }
      .val-5 {
        left: 90%;
      } 
    }
  }
`;

const DriverList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  flex: 0 1 100%;
  display: flex;
  flex-wrap: wrap;
  
  @media${TABLET} {
   min-width: 200px;
   max-width: 400px;
   flex: 0 1 350px;
   padding-left: 30px;
   flex-direction: column;
  }
`;

const DriverListItem = styled.li`
  position: relative;
  margin-bottom: 6px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
  
  &.no-result {
    pointer-events: none;
    opacity: .4;
  }
  
  .item-results {
    position: absolute;
    left: 40px;
    bottom: -10px;
    font-size: 13px;
  }
  
  .driver-index {
    transition: all .3s ease-in-out;
    flex: 0 0 24px;
  }
  
  &:hover {
    .driver-index {
      transform: scale(1.15);
      transform-origin: center;
    }
  }
  
  @media${TABLET} {
    margin-right: 0;
    margin-bottom: 8px;
    
    .driver-index {
      flex: 0 0 30px;
    }
    
    .driver-title {
       white-space: wrap;
    }
  }
`;

const ItemNumber = styled.span`
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  margin-right: 5px;
  
  @media${TABLET} {
    width: 30px;
    height: 30px;
    font-size: 15px;
    margin-right: 8px;
  }
`;

const ItemTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  @media${TABLET} {
    font-size: 1rem;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/driver-result-map.js